import { useMutation } from '@tanstack/react-query';
import download from 'downloadjs';
import { notify } from '../../../toaster';
import { METABASE_API_URL, metabaseApi } from '../../core/api';

export type ExportFormat = 'csv' | 'xlsx' | 'json';

type DownloadCardParams = {
  cardId: number;
  filename?: string;
  exportFormat: ExportFormat;
  format_rows?: boolean;
  pivot_results?: boolean;
};

const mimeTypes: Record<ExportFormat, string> = {
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  json: 'application/json',
};

export const useDownloadCard = () => {
  return useMutation({
    mutationFn: (payload: DownloadCardParams) =>
      metabaseApi.post(
        `${METABASE_API_URL}/card/${payload.cardId}/query/${payload.exportFormat}`,
        {
          format_rows: payload.format_rows,
          pivot_results: payload.pivot_results,
        },
        {
          responseType: 'blob',
        }
      ),
    onSuccess: (response, { filename, cardId, exportFormat }) => {
      download(
        response.data,
        filename || `card-${cardId}.${exportFormat}`,
        mimeTypes[exportFormat]
      );
      notify.default({
        title: 'Report was successfully exported.',
      });
    },
    onError: () => {
      notify.error({
        title: 'Failed to export report.',
      });
    },
  });
};
